import React from "react";
import { Modal } from "@sumprio/ui";
import ModalPortalRoot from "./ModalPortalRoot";

export interface SideModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  sideSize?: "sm" | "md" | "lg" | "xl";
  showFooterDivider?: boolean;
  showHeaderDivider?: boolean;
  showCloseButton?: boolean;
  closeOnBackdropClick?: boolean;
  closeOnEscape?: boolean;
}

export default function SideModal({
  open,
  onClose,
  title,
  children,
  footer,
  sideSize = "md",
  showFooterDivider = true,
  showHeaderDivider = true,
  showCloseButton = true,
  closeOnBackdropClick = false,
  closeOnEscape = false,
}: SideModalProps) {
  return (
    <ModalPortalRoot open={open} variant="side">
      <Modal
        variant="side"
        sideSize={sideSize}
        open={open}
        onClose={onClose}
        closeOnBackdropClick={closeOnBackdropClick}
        closeOnEscape={closeOnEscape}
        title={title}
        showCloseButton={showCloseButton}
        showCancelButton={false}
        showPrimaryButton={false}
        showSecondaryButton={false}
        footer={footer}
        showFooterDivider={showFooterDivider}
        showHeaderDivider={showHeaderDivider}
      >
        {children}
      </Modal>
    </ModalPortalRoot>
  );
}
